import { HttpClient } from '@angular/common/http';
import { API_CONSTANT } from './../../services/api.constant';
import { HttpClientService } from './../../services/http-client.service';
var DownloadService = (function () {
    function DownloadService(http, httpLocal) {
        this.http = http;
        this.httpLocal = httpLocal;
    }
    DownloadService.prototype.getDocumentRequestList = function (params) {
        return this.http.get(API_CONSTANT.documents_download, params);
    };
    DownloadService.prototype.deleteDocumentRequest = function (id) {
        return this.http.delete(API_CONSTANT.documents_download + id + '/');
    };
    DownloadService.prototype.createDocumentRequest = function (data) {
        return this.httpLocal.post(API_CONSTANT.create_document_request, data);
    };
    DownloadService.prototype.updateDocumentRequest = function (data) {
        return this.http.patch(API_CONSTANT.patch_document_request, data);
    };
    DownloadService.prototype.rejectDocumentRequest = function (data) {
        return this.http.patch(API_CONSTANT.reject_document_request, data);
    };
    return DownloadService;
}());
export { DownloadService };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download.service.ts.pre-build-optimizer.js